<template>
	<button
		class="menu-button"
		type="button"
		aria-label="Open menu"
		@click="$emit('toggle-sidebar')"
	>
		<span class="menu-button__bar"></span>
	</button>
</template>

<script>
export default { name: 'BurgerButton' }
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.menu-button {
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 12;
	display: inline-block;
	width: 40px;
	height: 40px;
	padding: 0;
	border: none;
	background: transparent;
	color: $white;
	cursor: pointer;

	.menu-button__bar,
	.menu-button__bar::before,
	.menu-button__bar::after {
		content: '';
		position: absolute;
		left: 0;
		display: block;
		height: 1px;
		border-radius: 2px;
		background: currentColor;
		transition: color 0.3s;
	}

	.menu-button__bar {
		top: 50%;
		width: 14px;
		transform: translateY(-50%);

		&::before {
			top: -5px;
			width: 11px;
		}

		&::after {
			bottom: -5px;
			width: 7px;
		}
	}

	&:hover .menu-button__bar {
		color: $semi-light-blue;
		animation: lineMiddleShrink 0.5s ease-in 0.08s forwards;

		&::before {
			animation: lineTopShrink 0.5s ease-in 0s forwards;
		}

		&::after {
			animation: lineBottomShrink 0.5s ease-in 0.15s forwards;
		}
	}
}

@keyframes lineTopShrink {
	0% {
		width: 11px;
	}
	30% {
		width: 5px;
	}
	70% {
		width: 5px;
	}
	100% {
		width: 11px;
	}
}

@keyframes lineMiddleShrink {
	0% {
		width: 14px;
	}
	30% {
		width: 4px;
	}
	70% {
		width: 4px;
	}
	100% {
		width: 14px;
	}
}

@keyframes lineBottomShrink {
	0% {
		width: 7px;
	}
	30% {
		width: 3px;
	}
	70% {
		width: 3px;
	}
	100% {
		width: 7px;
	}
}
</style>
